"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = settle;
exports.fetchAdapter = void 0;
var _axios = _interopRequireWildcard(require("axios"));
var _internals = require("../internals");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function settle(resolve, reject, response) {
  const {
    validateStatus
  } = response.config;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new _axios.AxiosError(`Request failed with status code ${response.status}`, [_axios.AxiosError.ERR_BAD_REQUEST, _axios.AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}

/**
 * Normalizes the given value to a string or an array of strings.
 * This function is stolen from axios and we hope it will work for us too. - https://github.com/axios/axios/blob/v1.x/lib/core/AxiosHeaders.js#L12
 * If the value is false or null, it is returned as is.
 * If the value is an array, each element is recursively normalized.
 * @param value The value to normalize.
 * @returns The normalized value.
 */
// @ts-expect-error -- TS does not like the recursive type
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return Array.isArray(value) ? value.map(normalizeValue) : String(value);
}

/**
 * Converts axios headers to native headers
 */
const constructHeaders = headers =>
// eslint-disable-next-line @typescript-eslint/no-unsafe-return -- We are sure that the headers are of type Headers
new Headers(Object.entries(headers.toJSON()).map(([key, value]) => [key, normalizeValue(value)]));
async function getRequest(config) {
  let response;
  const rawHeaders = constructHeaders(config.headers);
  const request = new Request((0, _internals.getUrl)(config), {
    headers: rawHeaders,
    keepalive: true
  });
  try {
    response = await fetch(request);
  } catch (error) {
    return new _axios.AxiosError('Network Error', _axios.AxiosError.ERR_NETWORK, config, request);
  }
  const axiosResponse = {
    status: response.status,
    statusText: response.statusText,
    config,
    request,
    headers: Object.fromEntries(Object.entries(new Headers(response.headers))),
    // Make a copy of headers
    // We will set data after
    data: undefined
  };
  if (response.status >= 200 && response.status !== 204) {
    switch (config.responseType ?? response.headers.get('content-type')) {
      case 'arraybuffer':
        axiosResponse.data = await response.arrayBuffer();
        break;
      case 'blob':
        axiosResponse.data = await response.blob();
        break;
      case 'json':
      case 'application/json':
        axiosResponse.data = await response.json();
        break;
      default:
        axiosResponse.data = await response.text();
        break;
    }
  }
  return axiosResponse;
}

/**
 * Custom implementation around fetch for axios. This is useful for environments where axios own adapters does not suffice (eg. edge runtime).
 * This custom adapter could be removed when axios introduces its own fetch adapter.
 *
 * https://github.com/axios/axios/issues/5523
 * https://github.com/axios/axios/pull/5146
 * @deprecated Use native axios 'fetch' adapter
 */
const fetchAdapter = async config => {
  const request = getRequest(config);
  const promiseChain = [request];
  if (config.timeout != null && config.timeout > 0) {
    promiseChain.push(new Promise(resolve => {
      setTimeout(() => {
        const message = config.timeoutErrorMessage ? config.timeoutErrorMessage : `timeout of ${config.timeout}ms exceeded`;
        resolve(new _axios.default.AxiosError(message, _axios.AxiosError.ECONNABORTED, config, request));
      }, config.timeout);
    }));
  }
  const data = await Promise.race(promiseChain);
  return new Promise((resolve, reject) => {
    if (data instanceof Error) {
      reject(data);
    } else {
      settle(resolve, reject, data);
    }
  });
};
exports.fetchAdapter = fetchAdapter;
//# sourceMappingURL=fetchAdapter.js.map